const HTMLBr = () => <br data-component="br" />;

export default HTMLBr;
